import { useEffect } from "react";

export default function QualificationSidebarHome() {
  useEffect(() => {
    const onClick = (event: MouseEvent) => {
      const target = event.target as HTMLElement | null;
      const button = target?.closest("aside nav button");
      if (!button || !button.textContent?.includes("Welder Qualifications")) return;

      const back = [...document.querySelectorAll<HTMLElement>("button, a")]
        .find(node => node.textContent?.trim().toLowerCase().includes("back to welders"));

      if (back) {
        event.preventDefault();
        back.click();
      }
    };

    document.addEventListener("click", onClick, true);
    return () => document.removeEventListener("click", onClick, true);
  }, []);

  return null;
}
